// How the system behaves for a company and for the people in it. A setting says how a company works
// rather than what it may do, and the company value is the default its people inherit.
// Defined on the backend in App\Security\Access\Settings.
//
// Not to be confused with the user's `settings`, which holds their own stored preferences.
export enum ClientSetting {
  // The company keeps invoices by hand, so the figures Cutwise would have charged are not shown.
  CustomBilling = 'setting.billing.custom',

  LabGrownStones = 'setting.stones.labGrown',
}
